import React, { useEffect, useState } from "react";
import Accordion from "react-bootstrap/Accordion";
import Select from "react-select";
import AddSanchit from "./AddEdit/AddSanchit";
import EditSanchit from "./AddEdit/EditSanchit";

const SanchitTab = () => {
  const [showExtraEntity, setShowExtraEntity] = useState(false);
  const [showCustomBroker, setShowCustomBroker] = useState(false);
  const [showSecondNotify, setShowSecondNotify] = useState(false);
  const [showThirdNotify, setShowThirdNotify] = useState(false);
  const [showTransporter, setShowTransporter] = useState(false);
  const [showShipTo, setShowShipTo] = useState(false);
  const [showBookingParty, setShowBookingParty] = useState(false);
  const [showSeller, setShowSeller] = useState(false);
  const [showImporter, setShowImporter] = useState(false);
  const [showBuyer, setShowBuyer] = useState(false);

  useEffect(() => {
    if (
      showCustomBroker == true ||
      showSecondNotify == true ||
      showThirdNotify == true ||
      showTransporter == true ||
      showShipTo == true ||
      showBookingParty == true ||
      showSeller == true ||
      showImporter == true ||
      showBuyer == true
    ) {
      setShowExtraEntity(true);
    } else {
      setShowExtraEntity(false);
    }
  }, [
    showCustomBroker,
    showSecondNotify,
    showThirdNotify,
    showTransporter,
    showShipTo,
    showBookingParty,
    showSeller,
    showImporter,
    showBuyer,
  ]);

  const shipperOptions = [
    { value: 1, label: "Rohit" },
    { value: 2, label: "Ravi" },
    { value: 3, label: "Sakshi" },
    { value: 4, label: "Abhishek" },
    { value: 5, label: "Shweta" },
  ];

  const [showAdd, setShowAdd] = useState(false);
  const handleCloseAdd = () => setShowAdd(false);
  const handleShowAdd = () => setShowAdd(true);

  const [showEdit, setShowEdit] = useState(false);
  const handleCloseEdit = () => setShowEdit(false);
  const handleShowEdit = () => setShowEdit(true);

  return (
    <>
      <div className="row border-bottom-2 pb-3">
        <div className="col-md-12">
          <div className="card px-3 py-2">
            <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-1">
              <div className="d-flex align-items-center flex-wrap row-gap-2">
                
              </div>
              <div className="d-flex align-items-center flex-wrap row-gap-2">
                <a className="btn btn-light me-2">Clear</a>
                <div
                  className="btn btn-primary cursor-pointer me-2"
                  onClick={handleShowAdd}
                >
                  <i className="ti ti-square-rounded-plus me-2" />
                  Add eSanchit
                </div>
              </div>
            </div>

            <div className="row">
              <table className="table table-striped table-sm">
                <thead>
                  <tr>
                    <th scope="col">
                      <input
                        type="checkbox"
                      />
                    </th>
                    <th scope="col">Doc. Level</th>
                    <th scope="col">Inv. Sr.No.</th>
                    <th scope="col">Item Sr.No.</th>
                    <th scope="col">Doc. IRN</th>
                    <th scope="col">Doc. Type</th>
                    <th scope="col">Doc. Ref. No.</th>
                    <th scope="col">ICEGATE ID</th>
                    <th scope="col">Doc. Issue date</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">-</th>
                    <th scope="col">-</th>
                    <th scope="col">-</th>
                    <th scope="col">-</th>
                    <th scope="col">-</th>
                    <th scope="col">-</th>
                    <th scope="col">-</th>
                    <th scope="col">-</th>
                    <th scope="col">
                      <div className="dropdown table-action">
                        <a
                          className="action-icon"
                          data-bs-toggle="dropdown"
                          href="/flexichain/airline"
                        >
                          <i className="fa fa-ellipsis-v" />
                        </a>
                        <div className="dropdown-menu dropdown-menu-right">
                          <div
                            className="dropdown-item cursor-pointer"
                            onClick={handleShowEdit}
                          >
                            <i className="ti ti-edit text-blue me-2" /> Edit
                          </div>
                        </div>
                      </div>
                    </th>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <AddSanchit showAdd={showAdd} handleCloseAdd={handleCloseAdd} />
      <EditSanchit showAdd={showEdit} handleCloseAdd={handleCloseEdit} />
    </>
  );
};

export default SanchitTab;
